export class Settings {
    public constructor(settings: any) {
        Object.assign(this, settings);
    }
}
export interface Settings {
    base: string;
    url(url: string): string;
    name: string;
    altName: string;
    author: string;
    description: string;
    card: string;
    minDate: string;
    mainMenu: Array<{ icon: [string, string]; title: string; to: string; exact: boolean }>;
    errorPages: {
        default: { icon: [string, string]; title: string; message: string; statusCode: number };
        [code: string]: { icon: [string, string]; title: string; message: string; statusCode: number };
    };
    cardTypeQuestionId: string;
    cardTypeAnswerId: string;
    programId: string;
    surveyId: string;
    patientConsentQuestion: string;
    patientConsentAnswer: string;
    isUSResidentQuestion: string;
    isUSResidentAnswer: string;
    isSixteenOrOlderQuestion: string;
    isSixteenOrOlderAnswer: string;
    hasInsuranceQuestion: string;
    hasInsuranceAnswer: string;
    notPayingCashQuestion: string;
    notPayingCashAnswer: string;
    coversCostPartiallyQuestion: string;
    coversCostPartiallyAnswer: string;
    coversCostFullyQuestion: string;
    coversCostFullyAnswer: string;
    notEnrolledQuestion: string;
    notEnrolledAnswer: string;
    hasPrescriptionQuestion: string;
    hasPrescriptionAnswer: string;
    hasDiscussedQuestion: string;
    hasDiscussedAnswer: string;
    indicationQuestion: string;
    indicationEpithelioidSarcoma: string;
    indicationFollicularLymphoma: string;
}
